import gql from 'graphql-tag'

/**
 * Query
 */
const ALL_ACTIVE_ONLY_NAME = gql`
    query workShiftsActive {
        workShiftsActive {
            id
            name
            checkin_time
            checkout_time
            lunch_time_ends
            lunch_time_entry
            week_days
            week_days_list {
                key
                name
            }
            is_active
            is_cumulative
            is_nocturnal
            status_text
        }
    }
`
const GET_WITH_PAGINATION = gql`
    query workShiftsWithPagination ($page: Int, $perPage: Int) {
        workShiftsWithPagination (page: $page, first: $perPage) {
            paginatorInfo {
                currentPage
                count
                hasMorePages
                perPage
                total
            }
            data {
                id
                name
                checkin_time
                checkout_time
                lunch_time_ends
                lunch_time_entry
                week_days
                week_days_list {
                    key
                    name
                }
                is_active
                is_cumulative
                is_nocturnal
                status_text
            }
        }
    }
`
/**
 * Mutations
 */
 const CREATE = gql`
 mutation createWorkShift ($input: WorkShiftCreateInput!) {
    createWorkShift (input: $input) {
         id
         name
         is_active
         status_text
     }
 }
`

const UPDATE = gql`
 mutation updateWorkShift ($id: ID!, $input: WorkShiftCreateInput!) {
    updateWorkShift (id: $id, input: $input) {
         id
         name
         is_active
         status_text
     }
 }
`

const CHANGE_STATUS = gql`
 mutation changeStatusWorkShift ($id: ID!, $input: WorkShiftChangeStatusInput!) {
    changeStatusWorkShift (id: $id, input: $input) {
         id
         name
         is_active
         status_text
     }
 }
`

const DELETE = gql`
 mutation deleteWorkShift ($id: ID!) {
    deleteWorkShift (id: $id) {
         id
         name
         is_active
         status_text
     }
 }
`
export {
    ALL_ACTIVE_ONLY_NAME,
    GET_WITH_PAGINATION,
    CREATE,
    UPDATE,
    CHANGE_STATUS,
    DELETE
}
